import { render, staticRenderFns } from "./Chronica.vue?vue&type=template&id=2810dd17&scoped=true&"
import script from "./Chronica.vue?vue&type=script&lang=js&"
export * from "./Chronica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810dd17",
  null
  
)

export default component.exports